import { Maximize01Icon } from "vega-icons";

import { AnalyticsEvent } from "@vega-api/custom/analytics/analyticsEvents";
import { useAnalytics } from "@vega-api/custom/hooks/useAnalytics";
import { type DealDataRoom } from "@vega-api/generated/types/dealDataRoom";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";
import { trackCoInvestDataRoomAccessed } from "@vega-core/utils/posthog/coInvestAnalytics";
import { useOrganization } from "@vega-modules/hooks/useOrganization";

type DataRoomAccessCardProps = {
  dataRoom: DealDataRoom;
  dealOpportunityId?: string;
  dealId?: string;
};

export const DataRoomAccessCard = ({
  dataRoom,
  dealOpportunityId,
  dealId,
}: DataRoomAccessCardProps) => {
  const { trackEvent } = useAnalytics();
  const { selectedOrgId: limitedPartnerId } = useOrganization();

  const handleAccessDataRoom = () => {
    trackEvent(AnalyticsEvent.COINVEST_DATA_ROOM_ACCESSED, undefined, {
      dealId,
      dealOpportunityId,
      limitedPartnerId,
    });
    trackCoInvestDataRoomAccessed({
      dealOpportunityId: dealOpportunityId ?? "",
      dealId,
    });
  };

  return (
    <div
      className="border border-background/tertiary rounded-companyBorderRadius p-3 lg:p-4 bg-background/card"
      data-testid="data-room-access-card"
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <div className="flex items-center gap-3 min-w-0 flex-1 w-full sm:w-auto">
          <span className="body-base-regular text-text/primary break-words sm:truncate">
            {dataRoom.dataRoomProvider.displayName}
          </span>
        </div>
        <ThemedButton
          as="a"
          className="flex-shrink-0 w-full sm:w-auto"
          dataTestId={`access-data-room-${dataRoom.dataRoomProvider.name}`}
          href={dataRoom.dataRoomUrl}
          icon={<Maximize01Icon />}
          onClick={handleAccessDataRoom}
          rel="noopener noreferrer"
          size="small"
          target="_blank"
          variant="secondary"
        >
          {m.coInvestments_accessDataRoom_accessButton()}
        </ThemedButton>
      </div>
    </div>
  );
};
